import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=2eb206ea&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "lity/dist/lity.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./InvoiceDetails.vue?vue&type=style&index=1&id=2eb206ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb206ea",
  null
  
)

export default component.exports